<template>
  <v-form
    method="POST"
    action="/login"
  >
    <csrf-token />
    <v-row>
      <v-col cols="2" />
      <v-col>
        <v-text-field
          class="justify-center"
          name="username"
          :label="t('global.username')"
          required
          autofocus
        />
        <password-input name="password" />

        <v-switch
          class="mb-7 mt-n2 text-label"
          name="remember"
          color="primary"
        >
          <template #label>
            <span class="text-font">
              {{ t('login.remember_me') }}
            </span>
          </template>
        </v-switch>

        <v-btn
          type="submit"
          color="secondary"
          block
          size="large"
          :text="t('login.title')"
          class="mb-3"
        />

        <v-btn
          class="text-center w-100 text-caption font-weight-medium"
          variant="plain"
          color="primary"
          to="/password/request"
          :text="t('password.forgotten')"
        />
        <v-btn
          class="text-center w-100 mb-2 text-caption font-weight-medium"
          variant="plain"
          color="primary"
          to="/username/recovery"
          :text="t('login.forgotten_username')"
        />
        <cookie-consent class="mt-8" />
      </v-col>
      <v-col cols="2" />
    </v-row>
    <div class="d-flex justify-end">
      <language-switcher
        icon
        @update="handlePreferredLanguageUpdate"
      />
    </div>
    <input
      v-if="preferredLanguage"
      type="hidden"
      name="preferred_language"
      :value="preferredLanguage"
    >
  </v-form>
</template>

<script setup lang="ts">
import CsrfToken from '@/components/CsrfToken.vue';
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import CookieConsent from './CookieConsent.vue';
import LanguageSwitcher from './LanguageSwitcher.vue';
import PasswordInput from './PasswordInput.vue';

const { t } = useI18n();
const preferredLanguage = ref<string | undefined>();

function handlePreferredLanguageUpdate(language: string) {
  preferredLanguage.value = language;
}
</script>
